import React from 'react'
import { Box, Typography } from '@mui/material'
import { DataGridTable } from 'components'
import { getRecentTeamDrivingTableColumns } from './recentTeamDrivingTableData'
import { exportTableAsCSV } from 'tools/helper'
import strings from 'strings'
import { useGridApiRef, GridRowHeightParams } from '@mui/x-data-grid'

const e = strings.CSV_EXPORT

interface IRecentTeamDrivingTableProps {
  data: any[]
  loading: boolean
  truncateDriverDisplay: (
    name: string,
    id: string,
    maxLength?: number
  ) => { name: string; id: string }
  getEstimatedRowHeight: ({
    model,
    densityFactor,
  }: GridRowHeightParams) => number | null
}

const RecentTeamDrivingTable: React.FC<IRecentTeamDrivingTableProps> = ({
  data,
  loading,
  truncateDriverDisplay,
  getEstimatedRowHeight,
}) => {
  const apiRef = useGridApiRef()

  const handleExport = () => {
    const csvString = apiRef.current.getDataAsCsv()
    exportTableAsCSV(csvString, e.RECENT_TEAM_DRIVING_CSV_EXPORT_NAME)
  }

  const tableMenuItems = [
    {
      label: e.DOWNLOAD_AS_CSV,
      key: 'export',
      action: () => {
        handleExport()
      },
    },
  ]

  return (
    <Box>
      <Typography variant="h2" color="text.primary" gutterBottom sx={{ mb: 2 }}>
        Recent Team Driving (same vehicle on same day)
      </Typography>
      <Typography
        variant="body1"
        color="text.secondary"
        gutterBottom
        sx={{ mb: 2 }}
      >
        Showing team driving instances over last 30 days
      </Typography>
      <DataGridTable
        apiRef={apiRef}
        showTitle={false}
        data={data}
        loading={loading}
        columns={getRecentTeamDrivingTableColumns(truncateDriverDisplay)}
        columnVisibilityModel={{
          rowId: false,
          numDrivers: false,
        }}
        multiSearchFilter={false}
        checkboxSelection={false}
        totalCount={data.length}
        getRowId={(row: any) => row.rowId}
        menuList={tableMenuItems}
        useDynamicRowHeight={true}
        getEstimatedRowHeight={getEstimatedRowHeight}
      />
    </Box>
  )
}

export default RecentTeamDrivingTable
